<ng-container *ngIf="vo$ | async; let vo">
	<app-page>
		<app-page-header>
			<app-breadcrumb [paths]="paths"></app-breadcrumb>
		</app-page-header>

		<app-page-actions>
			<button
				matTooltip="new"
				id="{{ cmpId }}-new-btn"
				i18n-matTooltip="@@general.action.new"
				mat-icon-button
				color="primary"
				(click)="createNewDatablock()">
				<mat-icon [svgIcon]="DcIcons.AddElement"></mat-icon>
			</button>
		</app-page-actions>

		<app-page-content>
			<app-panel
				headerHeight="3rem"
				isAlwaysOpen="true"
				hasSearchableGrid="true"
				hasRefresh="true"
				maxActionsCount="6"
				[actionsAvailable]="toggleActions"
				[itemsCount]="vo.list.elements.size"
				[actions]="panelActions"
				(refresh)="refresh()"
				(search)="search($event)">
				<span panel-info>
					<div *ngIf="selectionCount">
						<span>{{ selectionCount }} &#32;</span>
						<span i18n="@@expositions.columns.config.selectedElements">
							Elements selectionnée
						</span>
					</div>
				</span>
				<div panel-title class="app-panel__title">
					<mat-icon [svgIcon]="GdIcons.DataBlock"></mat-icon>
					<span i18n="@@datablock.list.title">Datablocks</span>
				</div>
				<dx-data-grid
					keyExpr="id"
					[elementAttr]="{ id: 'datablock-list', class: 'app-datablock-list' }"
					[dataSource]="vo.list.elements | toArray"
					[hoverStateEnabled]="true"
					[showColumnHeaders]="true"
					[allowColumnResizing]="false"
					[columnAutoWidth]="false"
					[showRowLines]="false"
					[showColumnLines]="false"
					[rowAlternationEnabled]="false"
					[showBorders]="false"
					[width]="'100%'"
					[noDataText]="''"
					(onRowClick)="navigateToDatablock($event.data['id'])"
					(onCellHoverChanged)="onCellHover($event)"
					(onOptionChanged)="onOptionChange($event)"
					(onSelectionChanged)="onSelectionChange($event)"
					(onContentReady)="onGridContentReady()">
					<dxo-selection
						mode="multiple"
						showCheckBoxesMode="always"></dxo-selection>

					<dxo-header-filter [visible]="true"></dxo-header-filter>

					<dxo-load-panel
						shadingColor="rgba(0,0,0,0)"
						[indicatorSrc]="DcLoaders.LoaderInfinite"
						[height]="100"
						[width]="100"
						[enabled]="vo.isFirstLoad"
						[showIndicator]="true"
						[showPane]="true"
						[shading]="true"></dxo-load-panel>

					<!-- Fixable in position columns	-->
					<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

					<ng-container *ngFor="let col of vo.list.availableColumns | toArray">
						<dxi-column
							*ngIf="col.field === 'code'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[allowHeaderFiltering]="col.hasHeaderFilter"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'description'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[allowHeaderFiltering]="col.hasHeaderFilter"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'label'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[minWidth]="100"
							[width]="'25%'"
							cellTemplate="labelTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'tags'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[dataType]="col.type"
							[filterOperations]="[DxOperations.Contains, DxOperations.In]"
							[calculateFilterExpression]="calculateTagsHeaderFilterExpression"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="200"
							cellTemplate="tagsTemplate">
							<dxo-header-filter
								[dataSource]="tagsHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'persistenceState'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="false"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[calculateFilterExpression]="calculatePersistenceFilterExpression"
							[dataType]="col.type"
							[format]="col.format"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							cellTemplate="persistenceTemplate">
							<dxo-header-filter
								[dataSource]="isPersistedHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'expositionsCount'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="false"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[dataType]="col.type"
							[format]="col.format"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							cellTemplate="expositionsTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'updateDate'"
							[dataField]="col.field"
							[dataType]="col.type"
							[format]="col.format"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="'10rem'"
							cellTemplate="updateDateTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'creationDate'"
							[dataField]="col.field"
							[dataType]="col.type"
							[format]="col.format"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							cellTemplate="creationDateTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'updatedByAvatar'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="false"
							[alignment]="'left'"
							[dataType]="col.type"
							[format]="col.format"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="[
								DxOperations.Contains,
								DxOperations.NotContains,
								DxOperations.StartsWith,
								DxOperations.In
							]"
							[calculateFilterExpression]="
								calculateActionByHeaderFilterExpression
							"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							cellTemplate="updatedByAvatarTemplate">
							<dxo-header-filter
								[dataSource]="modifiedByHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'createdByAvatar'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="[
								DxOperations.Contains,
								DxOperations.NotContains,
								DxOperations.StartsWith,
								DxOperations.In
							]"
							[calculateFilterExpression]="
								calculateActionByHeaderFilterExpression
							"
							[dataType]="col.type"
							[format]="col.format"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							cellTemplate="createdByAvatarTemplate">
							<dxo-header-filter
								[dataSource]="actionByHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'isActive'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="false"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[dataType]="col.type"
							[format]="col.format"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="'5.5rem'"
							cellTemplate="statusTemplate">
							<dxo-header-filter
								[dataSource]="actifHeaderFilter"></dxo-header-filter>
						</dxi-column>
					</ng-container>
					<dxi-column
						[fixed]="false"
						[allowResizing]="false"
						[allowHiding]="false"
						[allowGrouping]="false"
						[allowSearch]="false"
						[allowSorting]="false"
						[alignment]="'left'"
						[visibleIndex]="vo.list.availableColumns.size + 1"
						[showInColumnChooser]="false"
						[width]="'10rem'"
						cellTemplate="actionsTemplate"></dxi-column>

					<div *dxTemplate="let cell of 'statusTemplate'">
						<app-badge class="status" *ngIf="!cell.data['isActive']">
							<span i18n="@@general.inactive">inactive</span>
						</app-badge>
					</div>
					<div class="label-template" *dxTemplate="let cell of 'labelTemplate'">
						<img
							[src]="cell.data['pictogramUrl']"
							[alt]="cell.data['pictogramUrl']" />
						<span
							class="label-template__label"
							id="{{ cmpId }}-{{ cell.data['label'] }}">
							{{ cell.data['label'] }}
						</span>
					</div>

					<div *dxTemplate="let cell of 'tagsTemplate'">
						<app-tag-configurator
							*ngIf="cell.data['tags'].length !== 0"
							displayMode="tags"
							configMode="View"
							[configuredTags]="cell.data['tags']"></app-tag-configurator>
					</div>
					<div
						class="persistence-template"
						*dxTemplate="let cell of 'persistenceTemplate'">
						<ng-container *ngIf="cell.data['isActionInProgress']">
							<app-loader [isLoading]="true" [size]="20"></app-loader>
							<button
								mat-icon-button
								class="persistence-stop"
								(click)="stopPersistence($event, cell.data)">
								<mat-icon [svgIcon]="DcIcons.StopAction"></mat-icon>
							</button>
						</ng-container>
						<ng-container *ngIf="!cell.data['isActionInProgress']">
							<app-overlay-badge
								[icon]="
									cell.data['persistenceState'].isPersisted
										? ComponentIcons.Depersist
										: ComponentIcons.Persist
								"
								[isOpen]="openedOverlayElement.persistence === cell.data['id']"
								(overlayDismiss)="closePersistencePopover()"
								(click)="openPersistencePopover($event, cell.data['id'])">
								<app-popover
									id="persistence-details-popover"
									overlayContent
									label="Persistence"
									i18n-label="@@datablock.list.column.persistence"
									[icon]="{ iconName: ComponentIcons.Persist }"
									(adbPopoverClose)="closePersistencePopover()">
									<div class="persistence-template__body">
										<div class="persistence-template__info">
											<span
												i18n="@@datablock.list.partitionCount"
												class="persistence-template__info-details">
												partition count
											</span>
											<span
												*ngIf="
													cell.data['persistenceState'].isPersisted;
													else empty
												">
												{{ cell.data['persistenceState'].count }}
											</span>
										</div>
										<div class="persistence-template__info">
											<span
												i18n="@@datablock.list.persistenceSize"
												class="persistence-template__info-details">
												persistence size
											</span>
											<span
												*ngIf="
													cell.data['persistenceState'].isPersisted;
													else empty
												">
												{{ cell.data['persistenceState'].size | fileSize }}
											</span>
										</div>
										<div class="persistence-template__info">
											<span
												i18n="@@datablock.list.executionDuration"
												class="persistence-template__info-details">
												execution duration
											</span>
											<span
												*ngIf="
													cell.data['persistenceState'].isPersisted;
													else empty
												">
												{{
													cell.data['persistenceState'].duration
														| toDayjsDuration
														| dayjsDurationFormat
												}}
											</span>
										</div>
										<div class="persistence-template__btns">
											<ng-container
												*ngIf="cell.data['persistenceState'].isPersisted">
												<button
													id="{{ cmpId }}-{{ cell.rowIndex }}-depersist-btn"
													mat-raised-button
													(click)="unpersistDatablock(cell.data)">
													<span i18n="@@datablock.list.action.depersist">
														depersist
													</span>
												</button>
												<button
													id="{{ cmpId }}-{{ cell.rowIndex }}-repersist-btn"
													[color]="'primary'"
													mat-raised-button
													(click)="repersistDatablock(cell.data)">
													<span i18n="@@datablock.list.action.repersist">
														repersist
													</span>
												</button>
											</ng-container>
											<button
												*ngIf="!cell.data['persistenceState'].isPersisted"
												id="{{ cmpId }}-{{ cell.rowIndex }}-persist-btn"
												[color]="'primary'"
												(click)="persistDatablock(cell.data)"
												mat-raised-button>
												<span i18n="@@datablock.list.action.persist">
													persist
												</span>
											</button>
										</div>
									</div>
								</app-popover>
								<ng-template #empty>-</ng-template>
							</app-overlay-badge>
							<span *ngIf="cell.data['persistenceState'].isPersisted">
								{{
									cell.data['persistenceState'].date | date: 'yyyy-MM-dd HH:mm'
								}}
							</span>
						</ng-container>
					</div>
					<div *dxTemplate="let cell of 'expositionsTemplate'">
						<ng-container *ngIf="cell.data['expositionsCount'].totalCount > 0">
							<app-overlay-badge
								matTooltip="expositions"
								i18n-matTooltip="@@datablock.list.column.expositions"
								[icon]="ComponentIcons.Exposition"
								[value]="cell.data['expositionsCount'].totalCount"
								[isOpen]="openedOverlayElement.exposition === cell.data['id']"
								(overlayDismiss)="closeExpositionPopover()"
								(click)="openExpositionPopover($event, cell.data['id'])">
								<app-popover
									id="expositions-details-popover"
									overlayContent
									label="Expositions"
									i18n-label="@@datablock.list.column.expositions"
									[icon]="{ iconName: ComponentIcons.Exposition }"
									(adbPopoverClose)="closeExpositionPopover()">
									<div class="expositions-template__body">
										<div class="expositions-template__info">
											<span
												i18n="@@datablock.list.expositionCount.totalCount"
												class="expositions-template__info-details">
												exposition total
											</span>
											<span
												*ngIf="
													cell.data['expositionsCount'].totalCount != undefined;
													else empty
												">
												{{ cell.data['expositionsCount'].totalCount }}
											</span>
										</div>
										<div class="expositions-template__info">
											<span
												i18n="@@datablock.list.expositionCount.availableCount"
												class="expositions-template__info-details">
												expositions actives
											</span>
											<span
												*ngIf="
													cell.data['expositionsCount'].availableCount !=
														undefined;
													else empty
												">
												{{ cell.data['expositionsCount'].availableCount }}
											</span>
										</div>
									</div>
								</app-popover>
							</app-overlay-badge>
						</ng-container>
					</div>
					<div *dxTemplate="let cell of 'updateDateTemplate'">
						<span>
							{{ cell.data['updateDate'] | date: 'yyyy-MM-dd HH:mm' }}
						</span>
					</div>
					<div *dxTemplate="let cell of 'creationDateTemplate'">
						<span>
							{{ cell.data['creationDate'] | date: 'yyyy-MM-dd HH:mm' }}
						</span>
					</div>

					<div
						*dxTemplate="let cell of 'updatedByAvatarTemplate'"
						class="avatar-template">
						<app-avatar
							*ngIf="cell.data['updatedByAvatar']"
							[avatar]="cell.data['updatedByAvatar']"
							[withTooltip]="true"></app-avatar>
					</div>
					<div
						*dxTemplate="let cell of 'createdByAvatarTemplate'"
						class="avatar-template">
						<app-avatar
							*ngIf="cell.data['createdByAvatar']"
							[avatar]="cell.data['createdByAvatar']"
							[withTooltip]="true"></app-avatar>
					</div>

					<div
						class="actions-column-template"
						*dxTemplate="let cell of 'actionsTemplate'">
						<div [hidden]="cell.rowIndex !== currentlyHovered">
							<button
								id="{{ cmpId }}-{{ cell.rowIndex }}-create-from-db-btn"
								mat-icon-button
								class="actions-column-template__btn"
								matTooltip="create-datablock"
								i18n-matTooltip="@@datablock.list.action.createFromDatablock"
								(click)="createFromDatablock($event, cell.data['id'])">
								<mat-icon
									[svgIcon]="ActionIcons.CreateFromDatablock"></mat-icon>
							</button>
							<button
								id="{{ cmpId }}-{{ cell.rowIndex }}-export-btn"
								mat-icon-button
								class="actions-column-template__btn"
								matTooltip="export-datablock"
								i18n-matTooltip="@@datablock.list.action.export">
								<mat-icon
									[svgIcon]="ActionIcons.ExportDatablock"
									(click)="exportDatablock($event, cell.data)"></mat-icon>
							</button>
							<button
								id="{{ cmpId }}-{{ cell.rowIndex }}-delete-btn"
								mat-icon-button
								class="actions-column-template__btn"
								matTooltip="delete-datablock"
								i18n-matTooltip="@@datablock.list.action.delete"
								(click)="deleteDatablockRow($event, cell.data)">
								<mat-icon [svgIcon]="ActionIcons.Delete"></mat-icon>
							</button>
							<button
								id="{{ cmpId }}-{{ cell.rowIndex }}-actions-menu-btn"
								mat-icon-button
								class="actions-column-template__btn"
								(click)="rowMenuOpen($event, cell.rowIndex)"
								[matMenuTriggerFor]="actions"
								[matMenuTriggerData]="{ $implicit: cell.data }">
								<mat-icon [svgIcon]="DcIcons.MenuMoreOptionsHandle"></mat-icon>
							</button>
							<mat-menu #actions="matMenu">
								<ng-template matMenuContent let-data>
									<button
										*ngFor="
											let a of cell.data['isActive']
												? activeRowActions
												: disabledRowActions
										"
										id="{{ cmpId }}-{{ cell.rowIndex }}-{{ a.actionName }}-btn"
										(click)="a.action(data)"
										mat-menu-item>
										<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
										<span>{{ a.description }}</span>
									</button>
								</ng-template>
							</mat-menu>
						</div>
					</div>

					<dxo-group-panel [visible]="true"></dxo-group-panel>

					<!-- Filterable columns	-->
					<dxo-filter-row
						[visible]="vo.list.elements.size !== 0"></dxo-filter-row>

					<!-- Sorting	-->
					<dxo-sorting mode="multiple"></dxo-sorting>

					<!-- Pagination -->
					<dxo-paging [pageSize]="pageSize"></dxo-paging>
					<dxo-pager
						[visible]="true"
						[showPageSizeSelector]="true"
						[allowedPageSizes]="allowPageSizes"></dxo-pager>

					<dxo-column-chooser
						[allowSearch]="true"
						[enabled]="false"
						[mode]="'select'">
						<dxo-selection
							[allowSelectAll]="true"
							[recursive]="false"></dxo-selection>
					</dxo-column-chooser>

					<dxo-filter-panel [visible]="true"></dxo-filter-panel>

					<!-- State persistence	-->
					<dxo-state-storing
						type="custom"
						[enabled]="true"
						[savingTimeout]="160"
						[customLoad]="loadState"
						[customSave]="saveState"></dxo-state-storing>
				</dx-data-grid>
				<ng-container
					*ngIf="!vo.isLoading && vo.list.elements.size === 0"
					[ngTemplateOutlet]="noData"></ng-container>
			</app-panel>
		</app-page-content>
	</app-page>
</ng-container>

<ng-template #noData>
	<div class="no-data-template">
		<mat-icon [svgIcon]="GdIcons.DataBlock"></mat-icon>
		<app-button
			class="small"
			id="{{ cmpId }}-add-new"
			[leftIcon]="DcIcons.AddCircle"
			i18n="@@datablock.list.action.new"
			(click)="createNewDatablock()">
			new-datablock
		</app-button>
	</div>
</ng-template>
